import styled from "@emotion/styled";


export const P = styled.p`
  font-family: 'Barlow', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 30px;
  margin: 0px;
  letter-spacing: -0.128571px;
  text-align: center;
  color: #808397;
  @media (min-width: 769px) {
    text-align: left;
  }
`;

export const H1 = styled.h1`
  font-family: Fraunces;
  font-style: normal;
  font-weight: 900;
  font-size: 40px;
  line-height: 49px;
  text-align: center;
  letter-spacing: 6.25px;
  text-transform: uppercase; 
  color: #FFFFFF;
  @media (min-width: 769px) {
    font-size: 56px;
    line-height: 69px;
    letter-spacing: 8.75px;
  }
`;
export const H2 = styled.h2`
  font-family: Fraunces;
  font-weight: 900;
  font-size: 40px;
  line-height: 49px;
  letter-spacing: -0.285714px;
  margin: 0px;
  color: #24303E;
  text-align: center;
  @media (min-width: 769px) {
    text-align: left;
  }
`;

export const H3 = styled.h3`
  font-family: Fraunces;
  font-weight: 900;
  font-size: 28px;
  line-height: 35px;
  text-align: center;
  letter-spacing: -0.2px;
  color: #24554A;
  text-align: center;
`;

export const H4 = styled.h4`
  font-family: Fraunces;
  font-weight: 900;
  font-size: 18px;
  margin: 0px;
  line-height: 22px;
  text-align: center;
  letter-spacing: -0.128571px;
  color: #24303E;
  text-align: center;
`;

export const H5 = styled.h5`
  font-family: Fraunces;
  font-weight: 600;
  margin: 0px;
  font-size: 14px;
  line-height: 25px;
  text-align: center;
  letter-spacing: -0.1px;
  color: #A7AAAD;
  text-align: center;
`;

export const H6 = styled.h6`
  font-family: Fraunces;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 4px;
  color: #A7AAAD;
  width: 100%;
  text-align: center;

  @media (min-width: 769px) {
    font-size: 20px;
    line-height: 25px;
    letter-spacing: 5px;
  }
`;

export const Span = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: -0.114286px;
  color: #24554A;
`;
